import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DataService } from '../../common/data.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    constructor(private gservice: DataService, private dddd: MatDialog) { }

    ngOnInit() {
    }
}
